import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c6c65470&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6c65470')) {
      api.createRecord('c6c65470', component.options)
    } else {
      api.reload('c6c65470', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c6c65470&", function () {
      api.rerender('c6c65470', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/captains/wallet/transactions/index.vue"
export default component.exports